var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUpgrade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#17181C",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.045 30.8551C19.27 34.6051 24.811 35.6561 29.25 33.0931C31.344 31.8851 32.863 30.0621 33.714 27.9831C34.027 27.2171 33.66 26.3401 32.894 26.0271C32.127 25.7131 31.251 26.0811 30.937 26.8471C30.33 28.3311 29.245 29.6321 27.75 30.4951C24.71 32.2501 20.947 31.6321 18.611 29.2181L19.858 29.4861C20.668 29.6591 21.466 29.1431 21.639 28.3331C21.813 27.5241 21.297 26.7261 20.487 26.5521L15.643 25.5141C15.253 25.4301 14.846 25.5051 14.511 25.7221C14.177 25.9401 13.943 26.2811 13.861 26.6711L12.839 31.5191C12.668 32.3291 13.187 33.1251 13.997 33.2961C14.808 33.4671 15.604 32.9481 15.775 32.1381L16.045 30.8551ZM29.389 18.7821L28.142 18.5141C27.332 18.3411 26.534 18.8571 26.361 19.6671C26.187 20.4761 26.703 21.2741 27.513 21.4481L32.357 22.4861C32.747 22.5701 33.154 22.4951 33.489 22.2781C33.823 22.0601 34.057 21.7191 34.139 21.3291L35.161 16.4811C35.332 15.6711 34.813 14.8751 34.003 14.7041C33.192 14.5331 32.396 15.0521 32.225 15.8621L31.955 17.1451C28.73 13.3951 23.189 12.3441 18.75 14.9071C16.656 16.1151 15.137 17.9381 14.286 20.0171C13.973 20.7831 14.34 21.6601 15.106 21.9731C15.873 22.2871 16.749 21.9191 17.063 21.1531C17.67 19.6691 18.755 18.3681 20.25 17.5051C23.29 15.7501 27.053 16.3681 29.389 18.7821Z",
    fill: "#E7E7E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpgrade);
export default __webpack_public_path__ + "static/media/icon_upgrade.f86b9d54631930c4cb3982623ad607a0.svg";
export { ForwardRef as ReactComponent };